<div class="engines-option" artemisEnginesOptionDynamicHeight [searchEngineCount]="searchEngines?.length">
  <artemis-loading-spinner *ngIf="isLoading"></artemis-loading-spinner>
  <mat-checkbox
    class="custom-mat-checkbox"
    *ngFor="let s of searchEngines"
    [name]="s.serviceType"
    [(checked)]="s.isChecked"
    (change)="onSearchEngineChanged($event)">
    {{s.serviceName}}
  </mat-checkbox>
</div>
